import React, { useRef } from 'react'
import { ArrowRight, Target, Box, MessageCircleHeart, BarChart3, PenTool } from 'lucide-react'
import Reveal from 'components/Reveal'

const STEPS = [
  {
    letter: 'D',
    name: 'Delimitar',
    desc: 'Diagnóstico estratégico do contexto, percepção e tensões do público.',
    icon: Target,
    bg: '#491C47',
  },
  {
    letter: 'O',
    name: 'Organizar',
    desc: 'Estruturação da jornada de conteúdo e comunicação com progressão de percepção.',
    icon: Box,
    bg: '#0C0610',
  },
  {
    letter: 'R',
    name: 'Ressignificar',
    desc: 'Transformar estratégia em mensagens de posicionamento desejo e conversão.',
    icon: MessageCircleHeart,
    bg: '#491C47',
  },
  {
    letter: 'A',
    name: 'Analisar',
    desc: 'Calibração de tom, narrativa, identidade verbal e coerência de marca.',
    icon: BarChart3,
    bg: '#0C0610',
  },
  {
    letter: 'C',
    name: 'Criar',
    desc: 'Geração de criativo que converte e faz o público avançar em direção à marca.',
    icon: PenTool,
    bg: '#491C47',
  },
]

function TiltCard({ step, index }) {
  const cardRef = useRef(null)
  const Icon = step.icon

  const handleMouseMove = e => {
    const node = cardRef.current
    if (!node) return
    const rect = node.getBoundingClientRect()
    const relX = (e.clientX - rect.left) / rect.width - 0.5
    const relY = (e.clientY - rect.top) / rect.height - 0.5
    node.style.setProperty('--rx', `${(-relY * 14).toFixed(2)}deg`)
    node.style.setProperty('--ry', `${(relX * 14).toFixed(2)}deg`)
    node.style.setProperty('--gx', `${((relX + 0.5) * 100).toFixed(1)}%`)
    node.style.setProperty('--gy', `${((relY + 0.5) * 100).toFixed(1)}%`)
  }

  const handleMouseLeave = () => {
    const node = cardRef.current
    if (!node) return
    node.style.setProperty('--rx', '0deg')
    node.style.setProperty('--ry', '0deg')
  }

  return (
    <Reveal delay={index * 100} className='flex-1'>
      <div className='h-full animate-cardFloat' style={{ animationDelay: `${index * 0.35}s` }}>
        <div
          ref={cardRef}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          className='group relative flex h-full min-h-[300px] cursor-default flex-col overflow-hidden rounded-2xl p-8 transition-transform duration-200 ease-out will-change-transform md:min-h-[340px]'
          style={{
            backgroundColor: step.bg,
            boxShadow: '0 12px 30px rgba(69,26,95,0.25)',
            clipPath: 'polygon(36px 0, 100% 0, 100% 100%, 0 100%, 0 36px)',
            transform: 'perspective(1000px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg))',
            transformStyle: 'preserve-3d',
          }}
        >
          <div
            className='pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100'
            style={{
              background:
                'radial-gradient(240px circle at var(--gx, 50%) var(--gy, 50%), rgba(255,233,140,0.16), transparent 70%)',
            }}
          />
          <div className='mb-6 flex items-center justify-between'>
            <span className='font-display text-6xl font-black text-white'>{step.letter}</span>
            <Icon className='h-10 w-10' strokeWidth={1} style={{ color: '#FFE98C' }} />
          </div>
          <div className='mb-5 h-1.5 w-10 rounded-full' style={{ backgroundColor: '#FFE98C' }} />
          <h3 className='mb-3 text-2xl font-bold text-white'>{step.name}</h3>
          <p className='text-base leading-relaxed text-white/60'>{step.desc}</p>
        </div>
      </div>
    </Reveal>
  )
}

function Method() {
  return (
    <section id='metodo' className='section-h-full dorac-grid-bg py-24'>
      <div className='container mx-auto px-4'>
        <Reveal className='mb-16 text-center'>
          <span className='section-eyebrow'>Nossa metodologia</span>
          <h2 className='section-title mb-4'>
            O Método <span className='text-dorac-purple'>DORAC</span>
          </h2>
          <p className='section-subtitle mx-auto'>
            São 5 etapas que transformam comportamento humano em estratégia aplicada, posicionamento forte e{' '}
            <span className='font-semibold text-dorac-ink'>conversão consistente</span>. Não começamos no post,
            começamos pelas pessoas.
          </p>
        </Reveal>

        <div className='flex flex-col gap-6 md:flex-row md:items-stretch md:gap-0'>
          {STEPS.map((step, index) => (
            <React.Fragment key={step.letter}>
              <TiltCard step={step} index={index} />

              {index < STEPS.length - 1 && (
                <div className='hidden items-center justify-center px-2 md:flex'>
                  <span className='h-0.5 w-4 rounded-full' style={{ backgroundColor: '#FFE98C' }} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <Reveal className='mt-10 text-center'>
          <a href='#/metodo' className='btn-dorac gap-2 px-8 py-3'>
            Explorar o Método DORAC completo
            <ArrowRight className='h-4 w-4' />
          </a>
        </Reveal>
      </div>
    </section>
  )
}

export default Method
